// CSS Modules - component class name prefix: ShopStartPage__

<template>
  <div :class="$style.container">
    <ShopPageHeader />
    <HeroSlider :slides="slides" />
    <div :class="[$style.contentGrid, $style.firstGrid, 'columns']">
      <div :class="[$style.flexColumn, 'column is-two-thirds']">
        <h2>Top-Produktgruppen</h2>
        <BigNavButtons />
      </div>
      <div :class="[$style.flexColumn, 'column is-one-third']">
        <h2>WIKA-Gesamtprogramm</h2>
        <QuickAddBox :config="quickAddConfig" />
      </div>
    </div>
    <div :class="$style.contentGrid">
      <h2>Häufig gekaufte Produkte</h2>
      <ShopProductList />
    </div>
    <div :class="$style.contentGrid">
      <h2>Neuer Produkte</h2>
      <ShopProductList :isBestSellers="false" />
    </div>
    <ShopFooter />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import BigNavButtons from "../BigNavButtons/BigNavButtons.vue";
import ShopProductList from "../ShopProductList/ShopProductList.vue";
import ShopFooter from "../ShopFooter/ShopFooter.vue";
import HeroSlider from "../HeroSlider/HeroSlider.vue";
import ShopPageHeader from "../ShopPageHeader/ShopPageHeader.vue";
import QuickAddBox from "../QuickAddBox/QuickAddBox.vue";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer.vue";

export default {
  name: "ShopStartPage",
  components: {
    BigNavButtons,
    ShopProductList,
    ShopFooter,
    HeroSlider,
    ShopPageHeader,
    QuickAddBox,
    CookieDisclaimer
  },
  data() {
    return {
      slides: [
        {
          captionTop: false,
          captionLeft: false,
          image: "https://picsum.photos/1023/334?random=1",
          newWindow: false,
          text:
            "Wählen Sie schnell und einfach Ihr passendes Produkt aus unserem Standardportfolio an Messgeräten. Auswählen, bestellen, erhalten - natürlich made by WIKA.",
          title: "Willkommen im WIKA Online-Shop",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: true,
          image: "https://picsum.photos/1023/334?random=2",
          newWindow: false,
          text:
            "Auswählen, bestellen, erhalten – made by WIKA. In unserem WIKA Online-Shop stehen Ihnen unsere Produkte in gewohnter WIKA-Qualität zur Verfügung. Wählen Sie schnell und einfach Ihr passendes Produkt aus unserem Standardportfolio.",
          title: "WIKA Online-Shop",
          url: "#"
        },
        {
          captionTop: false,
          captionLeft: true,
          image: "https://picsum.photos/1023/334?random=3",
          newWindow: false,
          text:
            "Qualität ist das entscheidende Element des Erfolgs jedes Unternehmens. Wir wissen, worauf es in den Betriebsabläufen unserer Kunden ankommt. Deswegen machen wir bei der Qualität keine Kompromisse.",
          title: "Belastbarkeit liegt im Detail",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: true,
          image: "https://picsum.photos/1023/334?random=4",
          newWindow: false,
          text:
            "Effizienz bei WIKA heißt vor allem Effizienz für die Kunden von WIKA. Hochwertige Produkte, die punktgenaue Leistung bringen: Weniger dürfen Sie von uns nicht erwarten!",
          title: "Effizienz liegt im Detail",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: false,
          image: "https://picsum.photos/1023/334?random=5",
          newWindow: false,
          text:
            "Unsere Zuverlässigkeit basiert auf dem Bewusstsein der Verantwortung. Unsere Kunden können sich darauf verlassen, dass die WIKA-Geräte, die weltweit in ihren Anlagen eingebaut sind, jederzeit zuverlässig und exakt funktionieren.",
          title: "Zuverlässigkeit liegt im Detail",
          url: "#"
        }
      ],
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      },
      quickAddConfig: {
        selectOptionMax: 25,
        boxTitle: "Schnellbestellung",
        boxText:
          "Bestellen Sie einfach direkt Ihren gewünschten Artikel aus dem gesamten WIKA-Produktportfolio.",
        inputPlaceholder: "Artikelnummer",
        infoButtonText: "Info",
        addButtonText: "In den Warenkorb",
        loadingText: "wird geprüft...",
        addButtonLoadingText: "wird hinzugefügt...",
        addArticleFailedMessage:
          "Der Artikel konnte nicht zum Warenkorb hinzugefügt werden.",
        articleDetails: "Details",
        pricePerItem: "Preis (Stück)",
        currency: "€",
        currencyPosition: "%v %s",
        decimalSep: ",",
        thousandSep: ".",
        precisionValue: "2",
        quantity: "Anzahl",
        tax: "zzgl. MwSt.",
        shippingText: "Versand",
        shippingUrl: "/service_info_shipping_shop_de_de.WIKA",
        deliveryTime: "Lieferzeit",
        externalTransport: "1",
        readyForShipping: "Versandfertig",
        deliveryAfterProduction: "Versandfertig nach Produktion",
        singularWorkDayStr: "Werktag",
        pluralWorkDayStr: "Werktag(e)",
        warningHeadline: "Hinweis",
        warningNoValueSubmitted: "Bitte geben Sie eine Artikelnummer ein.",
        warningInvalidArticle:
          "Dies ist keine gültige Artikelnummer. Bitte kontaktieren Sie uns.",
        infoPopperContent: `
          <h4>Artikelnummer</h4>
          <h5 class="markup6">Was ist eine WIKA-Artikelnummer?</h5>
          <p>Die Artikelnummer spezifiziert die exakte Ausführung eines Produkts und kann somit sehr gut zur (Nach-)Bestellung genutzt werden. Sie ist nummerisch und besitzt 6, 7 oder 8 Stellen (z. B. 14139912). Bei einigen Messgeräten ist die Artikelnummer auf dem Produkt aufgedruckt bzw. eingraviert. Im Gegensatz zur Seriennummer (z. B. S# 11639110000) beginnt die Artikelnummer mit dem Präfix P# („Product number“).</p>
        `,
        infoPopperImage:
          "https://shop.wika.de/templates/images/quickaddinfo.jpg"
      }
    };
  }
};
</script>

<style module lang="scss">
@import "./ShopStartPage.scss";
</style>
